module.exports = __webpack_public_path__ + "static/media/autochilango-checkmark.0e62ceac.svg";